export const formattingForeignSS = (passport: string, dataISOcountries: any, country: string) => {
  const countryISOdata = dataISOcountries.find((item: any) => item.nombre.toLowerCase() === country.toLowerCase());
  const pasaporte = passport
  const isonum = countryISOdata.isonum
  const ISOpassport = pasaporte + isonum
  return { pasaporte, ISOpassport, isonum }
}